import { error } from '@sveltejs/kit';
import type { Models } from '@smartlinkdev/types';
import type { LayoutLoad } from './$types';
import { RoveIQService } from '$lib/services/roveiq';
import type { EnhancedExport } from 'lib/types';

export const load: LayoutLoad<{ venueExport: EnhancedExport; translations: Models.Translation[]}> = async ({
  fetch,
  params,
  parent,
}) => {
  await parent();
  let venueId: number;
  try {
    venueId = parseInt(params.venueId, 10);
  } catch (e) {
    throw error(404, 'Not found');
  }

  try {
    const roveiq = new RoveIQService(fetch);
    const venueExport = await roveiq.fetchExport(venueId);
    const translations = await roveiq.fetchTranslations(venueId);
    return {
      venueExport,
      translations,
    };
  } catch (e) {
    console.log('err:', e);
    throw error(500, 'Something went wrong');
  }
};
